import Vue from 'vue'
// import moment from 'moment'
import {
  Button,
  Lazyload,
  Tab,
  Tabs,
  List,
  Cell,
  CellGroup,
  Field,
  Popup,
  Dialog,
  Toast,
  Divider,
  PullRefresh,
  Overlay,
  Icon,
  Image,
  Picker,
  DatetimePicker,
  Checkbox
} from 'vant'
import { VueAxios, axios } from './utils/request'

import App from './App.vue'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'
import { Loading } from 'vant'
import dayjs from 'dayjs'
Vue.use(VueCookies)

// Vue.use(VueI18n)

// const i18n = new VueI18n({
//   locale: 'zh-cn', // 将要切换的语言，可以通过url拼的参数获取，用户行为select选择获取，本地manifest配置获取等，根据场景动态获取
//   messages: {
//     'zh-cn': require('./languages/zh-cn.json'),
//     'zh-tw': require('./languages/zh-tw.json'),
//     // en: require('./languages/en.json'),
//   },
// })

Vue.config.productionTip = false
Vue.use(Button)
  .use(Image)
  .use(Icon)
  .use(Lazyload)
  .use(Tab)
  .use(Tabs)
  .use(List)
  .use(Cell)
  .use(CellGroup)
  .use(Popup)
  .use(Picker)
  .use(Dialog)
  .use(Toast)
  .use(Field)
  .use(Divider)
  .use(PullRefresh)
  .use(Overlay)
  .use(Checkbox)
  .use(Loading)
  .use(DatetimePicker)

Vue.use(VueAxios)
let isCheckSign = false

Vue.$dayjs=dayjs()
var isWeixin = function () {
  // 判断是否是微信
  var ua = navigator.userAgent.toLowerCase()
  // eslint-disable-next-line
  return ua.match(/MicroMessenger/i) == 'micromessenger'
}
// function isIos() {
//   const u = navigator.userAgent
//   return u.indexOf('iPhone') > -1 || u.indexOf('Mac OS') > -1
// }
router.beforeEach((to, from, next) => {
  if (isWeixin() && isCheckSign === false && to.meta.checkAuth !== false) {
    axios
      .get('/auth/check')
      .then((res) => {
        isCheckSign = true
        if (res.errcode === 0) {
          if (res.result.user) {
            store.dispatch('setUserInfo', res.result.user)
          }
          else{
            store.dispatch('setUserInfo', {})
          }
          next()
        } else {
          console.log(to)

          const appId = res.result.appId // wx6557faf8f6b6eaf7
          console.log(appId)
          const redirectUri = encodeURIComponent(
            `${location.protocol}//${location.host
            }/api/auth/BaseCallback?r=${encodeURIComponent(
              location.href.replace('!', '')
            )}`
          )
          // console.log(redirectUri)
          window.location.replace(
            `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
          )
        }
      })
      .catch((err) => {
        console.log(err)
      })
  } else {
    // 其他浏览器访问,没登陆进入登陆页面
    next()
  }
})
// let firstUrl
router.afterEach(function (to, from) {
  // console.log(object);
  if (isWeixin()) {
    const url = encodeURIComponent(
      window.location.origin + to.fullPath.split('#')[0]
    )
    // if (!firstUrl) {
    //   firstUrl = url
    // }
    // if (isIos()) {
    //   url = firstUrl
    // }

    axios.get('/auth/jssdk?url=' + url + '').then((res) => {
      // console.log(res)
      if (res.errcode === 0) {
        // eslint-disable-next-line
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.result.jssdk.appId, // 必填，公众号的唯一标识
          timestamp: res.result.jssdk.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.result.jssdk.nonceStr, // 必填，生成签名的随机串
          signature: res.result.jssdk.signature, // 必填，签名
          jsApiList: [
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'hideMenuItems',
            'showMenuItems',
            'updateAppMessageShareData',
            'updateTimelineShareData',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'chooseWXPay',
            'closeWindow',
            'scanQRCode'
          ], // 必填，需要使用的JS接口列表
          success: function (res) {
            console.log('config-success')
            console.log(res)
          },
          fail: function (err) {
            console.log('config-err')
            console.log(err)
          }
        })
        console.warn('遇到config签名失败请确定后台是否设置ip白名单')
      }
    })
  }

  if (to.meta.title) {
    document.title = '汉高胶粘剂技术（广东）有限公司'
    var iframe = document.createElement('iframe')
    iframe.src = '/favicon.ico'
    iframe.style = 'display:none'
    document.body.appendChild(iframe)
    iframe.onload = function () {
      setTimeout(function () {
        document.body.removeChild(iframe)
      }, 0)
    }
  } else {
    document.title = '汉高胶粘剂技术（广东）有限公司'
  }
  window.viewportUnitsBuggyfill.refresh()
})

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
